import { isDevMode, Pipe, PipeTransform } from '@angular/core';
import * as currency_formatter from 'currency-formatter';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {
  
  transform(value: string | number,decimals = 2): string {
    //if(isDevMode()) console.log(`NumberFormatPipe transform: ${value}`)
    if(typeof value === 'string') value = parseFloat(value)
    return currency_formatter.format(value, {decimal:'.',thousand:',',precision:decimals})
  }
}
